<template>
  <div>
    <el-row class="m-0 width-100-p" :gutter="20">
      <el-col
        :span="$vuetify.display.width >= 1500 ? 6 : $vuetify.display.width >= 750 ? 12 : 24"
        :class="$vuetify.display.width >= 750 ? '' : 'width-100-p'"
        v-if="hasLocation"
      >
        <!-- Location Dropdown (Country -> States) -->
        <el-dropdown ref="estimDropdown" visible-change="trueOrfalse" trigger="click" class="filter-drop width-100-p" @command="handleFilter" :hide-on-click="false" >
          <el-button
            color="#0D3937"
            class="height-40  border-color-light rounded-3 width-100-p ml-1"
            :class="{'bg-me-primary': isOdd(scenarioId), 'bg-me-primary-1': isEven(scenarioId)}"
          >
            <svg class="stroke-icon width-20 height-20">
              <use href="@/assets/svg/icon-sprite.svg#stroke-filter-location"></use>
            </svg>
            <span class="text-white pl-3">
              <!-- Filter by {{ selectedCountry ? selectedCountry : (selectedState ? selectedState : "Location") }} -->
              Calculate by {{ selectedState ? selectedState : "Location" }}
            </span>
          </el-button>

          <!-- Dropdown Menu -->
          <template #dropdown>
            <el-dropdown-menu class="border-color-light" :style="{ width: '206.88px', backgroundColor: '#FFFFFF' }"
            :class="{'bg-me-primary': isOdd(scenarioId), 'bg-me-primary-1': isEven(scenarioId)}">

              <!-- If no country selected, filter countries and show -->
              <template v-if="!selectedCountry">
                <el-dropdown-item
                  v-for="(location, index) in states"
                  :key="index"
                  @click="selectCountry(location.country)"
                >
                  {{ location.country }}
                </el-dropdown-item>
              </template>

              <!-- If a country is selected, filter states and show -->
              <template v-if="selectedCountry">
                <el-dropdown-item
                  v-for="(region, regionIndex) in selectedStates"
                  :key="regionIndex"
                  @click="selectState(region)"
                >
                  {{ region }}
                </el-dropdown-item>

                <!-- Back button to go back to country selection -->
                <el-dropdown-item @click="resetCountry">
                  <i>Back to Countries</i>
                </el-dropdown-item>
              </template>
              
            </el-dropdown-menu>
          </template>
        </el-dropdown>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { convertToTitleCase } from '../common/common-tools';

export default{
  props: {
    applyFilter: {
      type: Function,
    },

    // receive scenarioID from index component scenarioid
    scenarioId: {
      type: Number,
      required: true
    },

  },
  emits:['updateForm'],

    data(){
        return{

            // date for filter by location
            // states: [ 
            //     {country: "Australia", states: ["NSW", "QLD", "VIC", "SA", "WA", "TAS"]},
            //     {country: "UK", states: ["North Scotland", "South Scotland", "North West England", "North East England", "Yorkshire", "North Wales and Merseyside", "West Midlands", "East Midlands", "South Wales", "East England", "South West England", "South England", "London", "South East England", "Ireland"]},
            //         ],
            states: [ 
                {country: "Australia", states: []},
                {country: "UK", states: []},
                    ],

            selectedCountry: "", // Track the selected country
            selectedStates: [],  // Store the states of the selected country
            selectedState: "",   // Track the selected state
            hasLocation: true,
            // date for filter by location

            // data form send to input form
            form: {
              "country" : this.selectCountry,
              "region" : this.selectedState,
            },

            // Location Filter DATA from session storage
            locationFilterData: null,

        }
    },
    methods: {
      // get filter data from session storage
      async getLocationFilterData(retry = true) {
        const data = await sessionStorage.getItem("estimatorLocationFilter");
        if (data) {
          this.locationFilterData = JSON.parse(data);
          // console.log('location data', this.locationFilterData);
          this.updateCountryState();
        } else {
          console.log('no location filter data found at session storage');
          this.locationFilterData = [];
          if (retry) {
            // Retry after a delay
            setTimeout(() => {
              this.getLocationFilterData(false);
            }, 1000); // Retry after 1 second
          }
          return;
        }
      },

      // update regions to filter Dropdown list
      updateCountryState() {

        try {
            
          const ukData = this.locationFilterData.UK;
          const ukStates = Object.keys(ukData).map(state => this.convertFilterRegions(state));
          const ukDropdown = this.states.find((loc) => loc.country === "UK");
          ukDropdown.states = ukStates;

          const auData = this.locationFilterData.AU;
          const auStates = Object.keys(auData).map(state => this.convertFilterRegions(state, true));
          const auDropdown = this.states.find((loc) => loc.country === "Australia");
          auDropdown.states = auStates;

        } catch(error) {
          console.log("error when update location filter", error);
          
        } finally {
          console.log("update location filter done");
        }

      },


      // use import function to convert region name from filter data 
      convertFilterRegions(str, uppercase=false, keepUnderscore=false){
        return convertToTitleCase(str, uppercase, keepUnderscore);
      },




        // check scenario id is even or odd
      isEven(id) {
          return id % 2 === 0;
        },

      isOdd(id) {
          return id % 2 !== 0;
        },
        // check scenario id is even or odd

      convertUKStates(states) {
        const newStates = states.toLowerCase().replace(/ /g, "_");
        return newStates;
      },
      convertAUStates(states) {
        const newStates = states.toLowerCase();
        return newStates;
      },

        selectCountry(country) {
        const location = this.states.find((loc) => loc.country === country);
        this.selectedCountry = country;
        this.selectedStates = location.states; // Update with selected country's states
    },

        selectState(state) {
        this.selectedState = state; // Set the selected state
        // console.log(`Selected Country: ${this.selectedCountry}`);
        // console.log(`Selected State: ${state}`); // Handle state selection logic
        this.handleVisible2(); // Close the dropdown after selecting a state
        if(this.selectedCountry === 'UK') {
          this.$emit('updateFilter',{'country': this.selectedCountry, 'region' : this.convertUKStates(state), 'regionBeforeConvert' : this.selectedState});
          this.handleApplyFilter();
        } else if (this.selectedCountry === 'Australia') {
          this.$emit('updateFilter',{'country': this.selectedCountry, 'region' : this.convertAUStates(state), 'regionBeforeConvert' : this.selectedState});
          this.handleApplyFilter();
        }
    },
        resetCountry() {
        this.selectedCountry = ""; // Reset country and go back to country selection
        this.selectedStates = [];
    },
        handleVisible2() {
            this.$refs.estimDropdown.handleClose(); // close filter list after state is choosen
            },

        handleApplyFilter() {
          this.applyFilter('location');
        },
    },
    async mounted(){
        //get location data
        await this.getLocationFilterData();

      // active handleclose();
        this.$nextTick(() => {
       
        if (this.$refs.estimDropdown) {
           
            // console.log("Dropdown is mounted and ready");
         
            this.$refs.estimDropdown.handleClose();
        }
        });

        

    }


}

</script>

<style scoped>

h2 {
    color: white;
}
span {
    color: white;
}
label{
    color: white;
    font-size:medium;
}
.checkbox{
    margin-right: 11.17px;
    width: 16px;
    height: 16px;
}


/* filter dropdown */
.el-dropdown-menu {
  width: 220px;
  height: 232.31px;
  flex-shrink: 0;
  background-color: #fff !important;
  /* color: white !important; */
  color: var(--35-green, #547477);
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 280%; /* 33.6px */
  letter-spacing: 0.5px;
  border: 0;
}

.el-dropdown-menu :deep(.el-dropdown-menu__item) {
  border-bottom: 1px solid transparent; 
  /* border-top: 1px solid transparent;  */
  border-image: url('./line-150.png') 3;
  padding: 10px 5px 10px 10px;
}


.el-dropdown-menu__item:not(.is-disabled):focus {
  background-color: #547477 !important;
}

/* .label-color > label {
  color: white !important;
  width: 80px !important;
}
.label-color > div > div {
  height: 100% !important;
  display: flex !important;
  align-items: center;
} */

.el-dropdown__list > .el-dropdown-menu {
  max-height: 200px;
  overflow-y: auto;
  overflow-x: hidden;
}

.el-radio-button__inner {
  padding-left: 8px !important;
  padding-right: 8px !important;
}


</style>